import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Our custom font-size utilities (index.css) are unknown to tailwind-merge by
 * default, so it falls back to treating any `text-*` class as one generic
 * group — which silently dropped `text-primary-foreground` in favour of
 * `text-meta` on every button using both (the Save button's invisible label).
 * Registering them as their own group keeps size and colour from colliding.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-micro',
        'text-meta',
        'text-note',
        'text-body',
        'text-lead',
        'text-display-sm',
        'text-display',
      ],
    },
  },
})

/** Merge conditional class names, resolving conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
